import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import * as _ from 'lodash';


@Injectable()
export class CapabilityEngineService {

    capabilities: any;
    appTypes: any;

    constructor(
        private _http: HttpClient
    ) { }


    addConfig(versionObj) {
        return this._http.put(environment.serverUrl + '/addVersion', versionObj);
    }

    saveCapabilities(data) {
        this.capabilities = undefined;
        this.capabilities = [...data.capabilities];

        this.appTypes = data.appType;
    }

    canPerform(data) {
        // tslint:disable-next-line:max-line-length
        return _.difference(data, this.capabilities).length === 0;   // data expects an array of the required capabilities, returns true/false
    }

    isFormhound() {
        if ((this.appTypes && this.appTypes.length > 1) || !this.appTypes) {
            return false;
        } 
        return true;
    }

    isOshaMshaForm(){
        if ((this.appTypes && this.appTypes.length > 0 && this.appTypes[0] !== "MSHA")) {
            return false
        }
        return true
    }

    getHeaders(capabilityType) {
        const header = new HttpHeaders().set('capability', capabilityType);
        return { headers: header };
    }

    clearCapabilities() {
        this.capabilities = undefined;
    }

}



// WEBPACK FOOTER //
// ./src/app/capabilityEngine.service.ts